import { CommunityFeed } from '@/components/CommunityFeed';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(CommunityFeed, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
